<form class="content" [formGroup]="chronicForm" (submit)="submit()">
  <mat-accordion multi="true">
    <mat-expansion-panel>
      <mat-expansion-panel-header class="accordion-description">{{ 'chronic_conditions' | translate }}</mat-expansion-panel-header>
      <div class="chronic-group">
        <form class="allergy-form" [formGroup]="newChronicICD10Form" (submit)="addChronicItem('diagnosis')">
          <div class="new-group">
            <mat-form-field>
              <mat-label>{{ 'add_chronic_condition' | translate }}</mat-label>
              <input matInput type="text" name="note" formControlName="diagnosis" gcFormField gcFormFieldNoError />
            </mat-form-field>
            <mat-form-field *ngIf="newChronicICD10Form.controls.diagnosis.value" class="note">
              <mat-label>{{ 'add_a_note' | translate }}</mat-label>
              <input matInput type="text" name="note" formControlName="note" gcFormField gcFormFieldNoError />
            </mat-form-field>
            <mat-form-field *ngIf="newChronicICD10Form.controls.diagnosis.value">
              <mat-label>{{ 'date_issued' | translate }}</mat-label>
              <input
                matInput
                type="text"
                autocomplete="off"
                [matDatepicker]="startpicker"
                formControlName="date"
                (focus)="startpicker.open()"
              />
              <mat-datepicker-toggle matSuffix [for]="startpicker"></mat-datepicker-toggle>
              <mat-datepicker #startpicker></mat-datepicker>
              <mat-error *ngIf="checkDateValid(newChronicICD10Form.controls.date)">{{ 'this_date_is_invalid' | translate }}</mat-error>
            </mat-form-field>
          </div>
          <div class="center-button">
            <button mat-flat-button type="submit" class="add-button" [disabled]="!newChronicICD10Form.controls.diagnosis.value">
              <mat-icon svgIcon="plus"></mat-icon>
              {{ 'add_conditions' | translate }}
            </button>
          </div>
        </form>
        <div *ngIf="chronicConditionsList.controls.length" class="divider"></div>
        <form class="allergy-form" [formGroup]="chronicForm">
          <div formArrayName="diagnosis">
            <div *ngFor="let chronicConditionItem of chronicConditionsList.controls; let i = index">
              <div [formGroupName]="i">
                <mat-card>
                  <mat-card-header>
                    <div class="title-text">{{ i + 1 }}. {{ chronicConditionItem.value.diagnosis }}</div>
                  </mat-card-header>
                  <mat-card-content>
                    <div class="description">
                      <div class="chronic-medication-group">
                        <mat-form-field class="note">
                          <input matInput type="text" name="note" formControlName="note" gcFormField gcFormFieldNoError />
                        </mat-form-field>
                        <mat-form-field>
                          <mat-label>{{ 'date_issued' | translate }}</mat-label>
                          <input
                            matInput
                            type="text"
                            autocomplete="off"
                            [matDatepicker]="startpicker"
                            formControlName="date"
                            (focus)="startpicker.open()"
                          />
                          <mat-datepicker-toggle matSuffix [for]="startpicker"></mat-datepicker-toggle>
                          <mat-datepicker #startpicker></mat-datepicker>
                        </mat-form-field>
                      </div>
                      <button class="delete-button-desktop small" mat-icon-button color="warn" (click)="remove('diagnosis', i)">
                        <mat-icon svgIcon="delete"></mat-icon>
                      </button>
                      <button mat-raised-button color="warn" class="delete-button-mobile" (click)="remove('diagnosis', i)">
                        <mat-icon svgIcon="delete"></mat-icon>
                        {{ 'delete' | translate }}
                      </button>
                    </div>
                  </mat-card-content>
                </mat-card>
              </div>
            </div>
          </div>
        </form>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header class="accordion-description">{{ 'chronic_medication' | translate }}</mat-expansion-panel-header>
      <div class="chronic-group">
        <form class="allergy-form" [formGroup]="newChronicMedicationForm" (submit)="addChronicItem('medication')">
          <div class="new-group">
            <mat-form-field>
              <mat-label>{{ 'add_medication' | translate }}</mat-label>
              <input matInput type="text" name="note" formControlName="medication" gcFormField gcFormFieldNoError />
            </mat-form-field>
            <mat-form-field class="note" *ngIf="newChronicMedicationForm.controls.medication.value">
              <mat-label>{{ 'add_a_note' | translate }}</mat-label>
              <input matInput type="text" name="note" formControlName="note" gcFormField gcFormFieldNoError />
            </mat-form-field>
            <mat-form-field *ngIf="newChronicMedicationForm.controls.medication.value && chronicConditionsList.length > 0">
              <mat-select
                [compareWith]="comparisonFn"
                formControlName="diagnosis"
                gcFormField
                gcFormFieldNoError
                placeholder="{{ 'link_to_diagnosis' | translate }}"
              >
                <mat-option value="null">{{ 'none' | translate }}</mat-option>
                <mat-option *ngFor="let option of selectedChronicConditionsList" [value]="option">
                  {{ option }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field *ngIf="newChronicMedicationForm.controls.medication.value">
              <mat-label>{{ 'date_issued' | translate }}</mat-label>
              <input
                matInput
                type="text"
                autocomplete="off"
                [matDatepicker]="startpicker"
                formControlName="date"
                (focus)="startpicker.open()"
              />
              <mat-datepicker-toggle matSuffix [for]="startpicker"></mat-datepicker-toggle>
              <mat-datepicker #startpicker></mat-datepicker>
              <mat-error *ngIf="checkDateValid(newChronicMedicationForm.controls.date)">{{ 'this_date_is_invalid' | translate }}</mat-error>
            </mat-form-field>
          </div>
          <div class="center-button">
            <button mat-flat-button type="submit" class="add-button" [disabled]="!newChronicMedicationForm.controls.medication.value">
              <mat-icon svgIcon="plus"></mat-icon>
              {{ 'add_medication' | translate }}
            </button>
          </div>
        </form>
        <div *ngIf="chronicMedicationsList.controls.length" class="divider"></div>
        <form class="allergy-form" [formGroup]="chronicForm">
          <div formArrayName="medication">
            <div *ngFor="let chronicMedicationItem of chronicMedicationsList.controls; let i = index">
              <div [formGroupName]="i">
                <mat-card>
                  <mat-card-header>
                    <div class="title-text">{{ i + 1 }}. {{ chronicMedicationItem.value.medication }}</div>
                  </mat-card-header>
                  <mat-card-content>
                    <div class="description">
                      <div class="chronic-medication-group">
                        <mat-form-field class="note">
                          <mat-label>{{ 'add_a_note' | translate }}</mat-label>
                          <input matInput type="text" name="note" formControlName="note" gcFormField gcFormFieldNoError />
                        </mat-form-field>
                        <mat-form-field *ngIf="chronicConditionsList.length > 0">
                          <mat-select
                            [compareWith]="comparisonFn"
                            formControlName="diagnosis"
                            gcFormField
                            gcFormFieldNoError
                            placeholder="{{ 'link_to_diagnosis' | translate }}"
                          >
                            <mat-option value="null">{{ 'none' | translate }}</mat-option>
                            <mat-option *ngFor="let option of selectedChronicConditionsList" [value]="option">
                              {{ option }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                        <mat-form-field>
                          <mat-label>{{ 'date_issued' | translate }}</mat-label>
                          <input
                            matInput
                            type="text"
                            autocomplete="off"
                            [matDatepicker]="startpicker"
                            formControlName="date"
                            (focus)="startpicker.open()"
                          />
                          <mat-datepicker-toggle matSuffix [for]="startpicker"></mat-datepicker-toggle>
                          <mat-datepicker #startpicker></mat-datepicker>
                        </mat-form-field>
                      </div>
                      <button class="delete-button-desktop small" mat-icon-button color="warn" (click)="remove('medication', i)">
                        <mat-icon svgIcon="delete"></mat-icon>
                      </button>
                      <button mat-raised-button color="warn" class="delete-button-mobile" (click)="remove('medication', i)">
                        <mat-icon svgIcon="delete"></mat-icon>
                        {{ 'delete' | translate }}
                      </button>
                    </div>
                  </mat-card-content>
                </mat-card>
              </div>
            </div>
          </div>
        </form>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
  <div class="center-button">
    <button
      class="button-submit"
      [ngClass]="{ primary: requestUuid === null, accent: requestUuid !== null }"
      mat-flat-button
      type="submit"
      [disabled]="chronicForm.invalid"
    >
      <mat-icon svgIcon="check"></mat-icon>
      {{ 'save_chronic_conditions' | translate }}
    </button>
  </div>
</form>
